import axios from '../../../api/axios.js'
// 2.0版本商品列表(商品改版成功后删除)
// export function findProductList (params) {
//     return axios.get('/product/api/spu/app/page', { params })
// }
export function findProductList (params) {
    return axios.get('/product/open-api/home-page', { params })
}
// spu商品详情(商品改版成功后删除)
// export const getGoodsDetail = (params) => {
//     return axios.get('/product/api/sku/query', { params })
// }
export const getGoodsDetail = params => {
    return axios.get(`/product/open-api/spu-detail/${params.id}`, { params })
}
// sku商品详情
export const getSkuGoodsDetail = params => {
    return axios.get('/ops/api/spike/sku', { params })
}
// 特价sku开放商品详情
export const getOpenSkuGoodsDetail = params => {
    return axios.get('/ops/openapi/spike/sku', { params })
}
// 商品组列表
export const getSpecs = params => {
    return axios.get(`/product/api/spu/group`, { params })
}
// 获取我的收藏列表
export const getMyCollect = params => {
    return axios.get('order/api/member/favorites', { params })
}
// 批量商品加入收藏夹
export const addAllCollect = params => {
    return axios.post('order/api/member/favorites/from-shopping-cart', params)
}
// 加入收藏夹
export const addFavorite = params => {
    return axios.post('order/api/member/favorites', params)
}
// 取消收藏夹
export const cancelFavorite = params => {
    return axios.put('order/api/member/favorites', params)
}
// 是否收藏
export const isCollect = params => {
    return axios.get('order/api/member/favorites/is-collect', { params })
}
// 返利说明
export const rebateShow = params => {
    return axios.get(`product/api/sku/${params.spuId}/rebate`, {})
}
// 获取商品附件资料
export const getGoodAttr = params => {
    return axios.get('/product/api/spu/attachments', { params })
}
// 确认订单商品获取
export const getProductData = params => {
    return axios.post('order/api/app/orders/confirm', params)
}
// 商品是否支持账期支付
export const getIsTerm = params => {
    return axios.post('payment/api/app/terms/whether-to-support-term', params)
}
// 账期信息
export const getTermInfo = params => {
    return axios.get('payment/api/terms/info', { params })
}
// 账期支付
export const paymentTerm = params => {
    return axios.post('payment/api/app/payments/term', params)
}
// 拼团商品详情
export const groudDetail = params => {
    return axios.get(`ops/openapi/group-items/detail`, { params })
}

// 拼团详情
export const getGroupsPurchaseDetail = params => {
    return axios.get(`order/api/group-participation/${params.groupParticipationId}`)
}

// 订单详情拼团信息
export const getOrderGroupDetail = params => {
    return axios.get(`order/api/group-participation/orders/${params.orderId}`)
}

// 会员是否可以参团购买
export const getIsGroup = params => {
    return axios.get(`order/api/group-participation/is-group/${params.groupId}`, { params })
}

// 拼团是否进行中
export const getGroupIsProcessing = params => {
    return axios.get(`ops/api/groups/${params.groupId}/is-processing`)
}

// 判断当前商品的价格是否可见，是否可以购买
export const isPriceData = params => {
    return axios.get('product/api/market/app/sku-visible', { params })
}

// 支付成功推荐商品
export const getRecommentd = params => {
    return axios.get('/product/api/spu/recommend', { params })
}
